import { useQuery } from '@tanstack/react-query'
import { adminApi } from '@/lib/api'
import { StatsCard } from '@/components/stats-card'
import { formatCurrency } from '@/lib/utils'
import {
  Building2,
  CheckCircle,
  Clock,
  TrendingUp,
  Users,
  Wallet,
  ArrowUpCircle,
} from 'lucide-react'

export default function DashboardPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin', 'overview'],
    queryFn: adminApi.getOverview,
  })

  if (isLoading) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-28 animate-pulse rounded-lg border bg-muted" />
          ))}
        </div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <p className="text-sm text-destructive">Gagal memuat data. Coba refresh halaman.</p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <p className="text-sm text-muted-foreground">Ringkasan keseluruhan platform OneIdol.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
        <StatsCard
          title="Total Tenant"
          value={data.total_tenants}
          description={`${data.active_tenants} aktif`}
          icon={Building2}
        />
        <StatsCard
          title="Tenant Baru Bulan Ini"
          value={data.new_tenants_this_month}
          icon={TrendingUp}
        />
        <StatsCard
          title="Total Revenue"
          value={formatCurrency(data.total_revenue_idr)}
          description="dari booking cheki verified"
          icon={Wallet}
        />
        <StatsCard
          title="Booking Verified"
          value={data.total_verified_bookings}
          icon={CheckCircle}
        />
        <StatsCard
          title="Menunggu Review"
          value={data.pending_proof_review}
          description="bukti pembayaran belum diverifikasi"
          icon={Clock}
        />
        <StatsCard
          title="Upgrade Plan"
          value={data.pending_upgrade_requests ?? 0}
          description="permintaan upgrade menunggu verifikasi"
          icon={ArrowUpCircle}
        />
        <StatsCard
          title="Tenant Aktif"
          value={data.active_tenants}
          description={`dari ${data.total_tenants} total`}
          icon={Users}
        />
      </div>
    </div>
  )
}
